<script>
import _ from 'lodash';
import { clientComputed, clientMethods, authComputed, authMethods, modalComputed, orgComputed, orgMethods } from '@/src/state/helpers';
export default {
  components: {},
  data() {
    return {
      firstName: null,
      lastName: null,
    };
  },
  computed: {
    ...clientComputed,
    ...authComputed,
    ...modalComputed,
    ...orgComputed,
    colors() {
      return {
        '--color':  this.primaryColor
      }
    },
    header() {
      return `Change ${this.inputModalLabel}`;
    },
  },
  methods: {
    ...clientMethods,
    ...authMethods,
    ...orgMethods,
    dynamicPayload() {
      let payload;
      if (this.inputModalLabel === 'Name') {
        payload = {
          client: {
            profile: {
              ...this.userProfile,
              firstName: this.firstName || this.userProfile.firstName,
              lastName: this.lastName || this.userProfile.lastName,
            },
          },
        };
      }
      return payload;
    },
    cancel() {
      this.$bvModal.hide('name-input-modal');
    },
    async change() {
      if (this.firstName !== null || this.lastName !== null) {
        const payload = await _.cloneDeep(this.dynamicPayload());
        const response = await this.updateClient({ clientId: this.clientId, trainerId: this.trainerId, payload });

        if (response.success === false) {
          console.error('response', response);
        } else {
          const updatedUser = _.cloneDeep(this.currentUser);
          updatedUser.user = response.client;
          this.setCurrentUser(updatedUser);
        }
      }
      this.$bvModal.hide('name-input-modal');
    },
  },
};
</script>

<template>
  <b-modal id="name-input-modal" centered :hide-header="true" :hide-footer="true" @hidden="cancel">
    <h1 class="header" :style="colors">{{ header }}</h1>
    <b-form-group description="" label="First Name" class="form-input">
      <b-form-input
        type="text"
        placeholder="Enter info"
        :value="userProfile.firstName"
        @change="firstName = $event"
      ></b-form-input>
    </b-form-group>
    <b-form-group description="" label="Last Name" class="form-input">
      <b-form-input type="text" placeholder="Enter info" :value="userProfile.lastName" @change="lastName = $event"></b-form-input>
    </b-form-group>
    <p @click.stop="cancel" class="close">Close & Cancel</p>
    <BaseButton class="large btn-primary button change" @click.stop="change">
      Change
    </BaseButton>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
::v-deep .modal-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 3px rgba(171, 171, 171, 0.5);

  .modal-body {
    display: flex;
    flex-direction: column;
    font-size: 17px;
    font-style: normal;
    justify-content: space-around;
    line-height: 28px;
    text-transform: capitalize;
    @include media('xxl', null) {
      margin-top: 3.9rem;
    }
    .header {
      color: var(--color);
      font-family: $base-font-family;
      font-size: 26.78px;
      font-weight: bold;
      line-height: 37px;
      margin-bottom: 1rem;
      text-align: center;
    }
    .form-group {
      legend {
        margin-bottom: 0;
      }
      .form-control {
        background: #f3f3f3;
        border: none;
        border-radius: 8px;
        height: 50px;
        width: 100%;
      }
    }
    .change {
      align-items: center;
      align-self: center;
      border: none;
      border-radius: 50px;
      bottom: -8%;
      color: #fff;
      display: flex;
      font-family: $roboto;
      font-weight: 500;
      justify-content: center;
      letter-spacing: 1px;
      max-width: 43%;
      position: absolute;
      z-index: 2;
    }

    .close {
      color: #000;
      font-family: $base-font-family;
      font-weight: 600;
      opacity: 0.5;
      padding: 2rem;
      text-align: center;
    }
  }
}
</style>
